/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const hardestChallengeSchema = z.object({
  challengeId: z.number(),
  title: z.string(),
  passed: z.number(),
  failed: z.number(),
});

export type IHardestChallenge = z.infer<typeof hardestChallengeSchema>;
